import * as React from "react";
import styled from "styled-components";
const ToastContainer = styled.div `
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	display: flex;
	z-index: 999;
`;
const ToastContent = styled.div `
	margin: auto;
	width: 400px;
	text-align: center;
	background-color: rgba(0, 0, 0, 0.7);
	border-radius: 2px;
	padding: 24px 56px;
	color: #fff;
	font-size: 14px;
	line-height: 16px;
`;
export default function Toast({ message }) {
    return (React.createElement(ToastContainer, null,
        React.createElement(ToastContent, null,
            React.createElement("span", null, message))));
}
